export default __webpack_public_path__ + "static/media/Societe-Hero.c74ff4af.jpg";